var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1589 18.5479H6.65098V10.4715H9.1589V18.5479ZM7.90359 9.36985C7.10164 9.36985 6.45117 8.7056 6.45117 7.90363C6.45117 7.51841 6.60419 7.14897 6.87658 6.87659C7.14896 6.6042 7.51839 6.45117 7.90359 6.45117C8.2888 6.45117 8.65823 6.6042 8.93061 6.87659C9.20299 7.14897 9.35602 7.51841 9.35602 7.90363C9.35602 8.7056 8.70528 9.36985 7.90359 9.36985ZM18.5452 18.5479H16.0427V14.6164C16.0427 13.6794 16.0238 12.4778 14.7388 12.4778C13.4349 12.4778 13.2351 13.4958 13.2351 14.5489V18.5479H10.7299V10.4715H13.1352V11.5732H13.1703C13.5051 10.9387 14.323 10.269 15.5432 10.269C18.0814 10.269 18.5479 11.9405 18.5479 14.1115V18.5479H18.5452Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6d4808fb3fb029531fa90586ec009bc6.svg";
export { ForwardRef as ReactComponent };